import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PrintService {
  isPrinting = false;
  previousUrl = '/';

  constructor(private router: Router) { }

  printDocument(prevUrl) {
    this.isPrinting = true;
    this.previousUrl = prevUrl;
    window.print();
  }
}